<template>
  <div>
    <v-btn color="primary" dark class="mb-2 cbtn" to="/companies/create"
      >{{ $t("customers.companies.new") }}</v-btn
    >

    <DataTable
      :url="api.ACTIONS.PASSENGERS"
      :titles="titles"
      :fields-hidden-main="['deleted_at', 'updated_at', 'telegram_username']"
      :fields-hidden-add="['id', 'deleted_at', 'created_at', 'updated_at']"
      :input-types-add="{
        password: 'password',
        password_confirmation: 'password',
      }"
      :formatter="formatters"
      :title="$t('customers.companies.title')"
      :enableEdit="false"
      :actions-extra-main="actionsExtraMain"
      :add-rules="rules"
      :enableAdd="false"
      :initialUrlSearchParams="par"
    />
  </div>
</template>
<style>
.cbtn {
  float: right;
  z-index: 1;
  margin-top: 20px;
  margin-right: 20px;
  padding: 0px 45px;
}
</style>
<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import i18n from "@/i18n";
const required = (val) =>
  (val !== null && val !== undefined) || i18n.t("customers.companies.requiredField");
const email = (val) =>
  (!!val && val.search(/^(\w|-|\.|_)+@(\w|-|\.|_)+\.\w+$/) !== -1) ||
  i18n.t("customers.companies.validEmail");
const past = (val) =>
  (!!val && moment(val).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")) ||
  i18n.t("customers.companies.pastDate");

export default {
  name: "Companies",
  title() {
    return this.$t("customers.companies.title");
  },
  components: { DataTable },
  data() {
    return {
      accommodation: "company",
      formatters: {
        created_at(value) {
          return moment(value).format(" DD MMM YYYY");
        },
      },
    };
  },
  computed: {
    rules() {
      return {
        username: [required],
        password: [required],
      };
    },
    par() {
      const par = new URLSearchParams();
      par.append("type", this.accommodation);
      return par;
    },

    titles() {
      return {
        id: this.$t("customers.companies.number"),
        full_name: this.$t("customers.companies.companyName"),
        phone_number: this.$t("customers.companies.phoneNumber"),
        created_at: this.$t("customers.companies.creationDate"),
        website: this.$t("customers.companies.website"),
        address: this.$t("customers.companies.address"),
        billing_email: this.$t("customers.companies.billingEmail"),
      };
    },
    actionsExtraMain() {
      return {
        prices: {
          title: this.$t("customers.companies.profile"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "PassengerProfile",
              params: { id: item.id },
            }),
        },
      };
    },
  },
};
</script>
